// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__11wDQ","title":"FrontImage_title__w0fma"};